var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubmitAnalytics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1544_245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.32422 14.7616C5.32422 14.8575 5.37745 14.9454 5.46211 14.9902C5.5467 15.035 5.64955 15.0292 5.72861 14.9751L7.50929 13.7592L5.32425 12.7178V14.7616H5.32422Z",
    fill: "#118F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9168 1.04867C15.8679 1.00358 15.8048 0.97998 15.741 0.97998C15.7025 0.97998 15.6642 0.988514 15.6279 1.00636L0.25549 8.54693C0.0983675 8.62415 -0.00105816 8.7846 8.49783e-06 8.96012C0.00107516 9.13541 0.102182 9.29476 0.260435 9.37027L4.31187 11.3007L12.4127 4.6425L5.31566 11.779L10.3627 14.1838C10.4247 14.2135 10.4924 14.2283 10.5594 14.2283C10.6165 14.2283 10.6731 14.2179 10.727 14.1967C10.8446 14.1502 10.938 14.0571 10.9846 13.9395L15.9816 1.33356C16.0212 1.23436 15.9954 1.12094 15.9168 1.04867Z",
    fill: "#118F5E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1544_245"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitAnalytics);
export default __webpack_public_path__ + "static/media/submitAnalytics.e7ed57dfbdd670f3353ea6a94bd503f5.svg";
export { ForwardRef as ReactComponent };